import { createRouter, createWebHashHistory } from 'vue-router'
import LoginPage from '../components/Login.vue'
import { verifyAuthenticatedSession } from '../utils/sessionAuth'

const RegisterPage = () => import(/* webpackChunkName: "route-auth" */ '../components/Register.vue')
const ResetPasswordPage = () => import(/* webpackChunkName: "route-auth" */ '../components/ResetPassword.vue')
const CarListPage = () => import(/* webpackChunkName: "route-carlist" */ '../components/CarList.vue')

const routes = [
  {
    path: '/',
    redirect: '/carlist'
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage
  },
  {
    path: '/register',
    name: 'Register',
    component: RegisterPage
  },
  {
    path: '/resetpwd',
    name: 'ResetPassword',
    component: ResetPasswordPage
  },
  {
    path: '/carlist',
    name: 'CarList',
    component: CarListPage,
    meta: { requiresAuth: true }
  },
  {
    path: '/:pathMatch(.*)*',
    redirect: '/carlist'
  }
]

const router = createRouter({
  history: createWebHashHistory('/pastel/'),
  routes
})

router.beforeEach(async to => {
  if (!to.meta.requiresAuth) return true
  if (await verifyAuthenticatedSession()) return true

  return {
    name: 'Login',
    query: { redirect: to.fullPath },
    replace: true
  }
})

export default router
